import { getSelfServicePaymentMethod } from '@/api/apiService';

export const usePaymentStore = defineStore('paymentStore', () => {
  const cardList = ref({ TOSS: null, STRIPE: null });

  const fetchTossCardInfo = async () => {
    try {
      const { data } = await getSelfServicePaymentMethod('TOSS');
      return data || null;
    } catch (error) {
      console.error('토스 카드 조회 실패', error);
      return null;
    }
  };

  const fetchStripeCardInfo = async () => {
    try {
      const { data } = await getSelfServicePaymentMethod('STRIPE');
      return data || null;
    } catch (error) {
      console.error('해외 카드 조회 실패', error);
      return null;
    }
  };

  const fetchUserCardList = async () => {
    const [tossCardInfo, stripeCardInfo] = await Promise.all([fetchTossCardInfo(), fetchStripeCardInfo()]);

    cardList.value = {
      TOSS: tossCardInfo,
      STRIPE: stripeCardInfo,
    };
  };

  return {
    cardList,
    fetchUserCardList,
  };
});
